export default __webpack_public_path__ + "static/media/TingerCover.c841121e.png";